module.exports = __webpack_public_path__ + "img/sprite.symbol.c460ad75.svg";